module.exports = __webpack_public_path__ + "static/img/3.1d54cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/add/3.png
// module id = LaqG
// module chunks = 1